import { render } from "./oap-favorite.vue?vue&type=template&id=65fecbfc"
import script from "./oap-favorite.vue?vue&type=script&lang=js"
export * from "./oap-favorite.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__